import React, { Component } from 'react';
import { MoonLoader } from 'react-spinners';
import Advise from '../../Advise/Advise';

import classes from './App.module.css';
//import assetMapping from '../../assets/assetMapping.json';
import Card from '../../elements/Card/Card';

import Footer from '../../components/Footer/Footer';
import SearchBar from '../../components/SearchBar/SearchBar';
import WeatherDetails from '../../components/WeatherDetails/WeatherDetails';
import Preview from '../../components/Preview/Preview';
import ErrorNotice from '../../components/ErrorNotice/ErrorNotice';

class App extends Component
{
  
 

  state = {
    searchBarInput: '',
    weatherDetails: {
      temperature: null,
      description: ''
    },
    loading: false,
    error: false
  }

  // Update state with current search bar input
  searchBarHandler = (e) => {
    this.setState({
      searchBarInput: e.target.value
    })
  }

  // Reset state after clicking on Logo or Try Again button
  tryAgainHandler = () => {
    this.setState({
      searchBarInput: '',
      weatherDetails: {},
      error: false
    })
  }

  // Fetch weather information and update state
  setWeather = () => {
    const city = this.state.searchBarInput;
    const API_KEY = process.env.REACT_APP_WEATHER_API_KEY;
    const API_URL = 'https://api.openweathermap.org/data/2.5/weather';
    const URL = API_URL + `?q=${city}&appid=${API_KEY}&units=metric`;
    this.setState({
      weatherDetails: {},
      loading: true,
      error: false
    }, () => {
      // Executed as callback function
      fetch(URL)
        .then(res => res.json())
        .then(data => {
          // If city exists, update weather details
          if(data.cod === 200) {
            this.setState({
              weatherDetails: {
                cityName: data.name,
                countryName: data.sys.country,
                temperature: data.main.temp,
                main: data.weather[0].main,
                description: data.weather[0].description
              },
              loading: false
            });
          } else {
            // If city doesn't exist, throw error
            throw data.cod
          }
        })
        .catch(err => {
          console.log(err);
          this.setState({
            loading: false,
            error: true
          });
        });
    });
  }

  render ()
  {
    

    // Conditionally render card content
    let cardContent = <Preview />;
    let cardAdvise = <Advise />;

    if (this.state.loading) {
      cardContent = <MoonLoader />;
    } else if (this.state.error) {
      cardContent = <ErrorNotice onClickHandler={this.tryAgainHandler} />;
    } else if (this.state.weatherDetails.temperature && this.state.weatherDetails.description !== '') {
      // Display weather information if temperature and description exists
      cardContent = <WeatherDetails data={this.state.weatherDetails} />;
    }

    return (
   
        <main className={classes.AppMain}>
          <SearchBar
            value={this.state.searchBarInput}
            onChangeHandler={this.searchBarHandler}
            onClickHandler={this.setWeather}
            error={this.state.error} />
          <Card>
            {cardContent}
         </Card>

         <Footer>
           { cardAdvise }
          </Footer>
          
      
       </main>

     
   
   
    );
  }
}

export default App;
